<template lang="pug">
	token-list
</template>

<script>
import TokenList from "@/components/tokens/TokenList";

export default {
	components: {
		TokenList
	}
};
</script>
